import request from '@hb/sharp-request';
import { BioAuthPo } from '@/po/bioAuth';
import { BioAuthVo } from '@/vo/bioAuth';
import { newGatewayUrl } from '@/constant';
import UploadImg from '@/api/uploadImg';
import { NativeOCRBack, NativeOCRFront, TencentSDKSignTypes } from '@/api/native/types';
import { IndentityCode } from '@/mixins/finance-identity/types';
import requestDefault from '@/shared/utils/request';
import { OcrProcessSourceEnum } from '@/shared/tools/ocr/enum';
import { OcrUploadParamsType } from './types';

// 新的 不用base64
export const uploadIdentity2 = (
  identity: BioAuthVo.Identity, dispatchNewUserStatus: boolean,
): Promise<boolean> => {
  if (dispatchNewUserStatus) {
    return requestDefault.postGate('f.user.bio.uploadOcrIdentity', { ...identity });
  }
  return requestDefault.postGate('f.user.upload.Identity', { ...identity });
};

// 更新单个渠道身份信息
export const updateSingelChannel = (productId: string): Promise<boolean> => request.postGate('f.user.id.card.refresh', {
  productId,
}, { baseURL: newGatewayUrl });


export const getIdentity = (dispatchNewUserStatus: boolean, processSource: OcrProcessSourceEnum):
  Promise<BioAuthPo.Result & { userInfo: BioAuthPo.Result }> => {
  if (dispatchNewUserStatus) {
    return requestDefault.postGate('f.user.bio.queryOcrIdentity', { processSource });
  }
  return requestDefault.postGate('f.user.bio.queryIdentity');
};

// 上传图片到OCR
export const onlineOCR = (
  params: OcrUploadParamsType,
  options?: Record<string, unknown>,
): Promise<NativeOCRFront | NativeOCRBack> => {
  const {
    front, pic, uploadType, processType, processSource, operationSource,
  } = params;
  const scene = front ? 'user-id1' : 'user-id0'; // 1正0反面身份证

  return request.postGate(
    'f.fate.ocr.ocr',
    {
      pic,
      scene: front === undefined ? undefined : scene,
      uploadType,
      processType,
      processSource,
      operationSource,
    },
    {
      baseURL: newGatewayUrl,
      ...options,
    },
  );
};

// ocr文件上传 身份证照片地址转换 支付宝小程序场景使用
export const ocrUpload = <T = string>(params: {
  fileUrl: string; // 图片url
  scene: string;// 身份证 正反面 oss对应场景
  extName?: string;// 扩展名
}): Promise<T> => request.postGate<T>('f.fate.ocr.upload', {
  ...params,
}, { baseURL: newGatewayUrl });

// 上传身份证
export const uploadIdCard = (
  base64: string,
  scene: string,
): Promise<string> => UploadImg.uploadIdToOss(base64, scene, {
  showLoading: undefined,
  showErrMsg: undefined,
});

// 1正0反面身份证
export const uploadFrontCard = (base64: string): Promise<string> => UploadImg.uploadIdToOss(base64, 'user-id1');

// 1正0反面身份证
export const uploadBackCard = (base64: string): Promise<string> => UploadImg.uploadIdToOss(base64, 'user-id0');

// 身份证清晰分<30
export const updatedIdentity = (params?: {
  scene?: OcrProcessSourceEnum,
}): Promise<IndentityCode> => request.postGate<IndentityCode>(
  'f.loan.userInfo.check',
  {
    ...params,
  },
  {
    baseURL: newGatewayUrl,
    showLoading: undefined,
  },
);

/**
 * 获取腾讯OCR SDK签名
 * https://yapi.hellobike.cn/project/4693/interface/api/354428
 */
export const getTencentSDKSign = (): Promise<TencentSDKSignTypes> => request.postGate(
  'f.fate.ocr.getTencentSDKSign',
  {},
  {
    baseURL: newGatewayUrl,
  },
);

const BioApi = {
  uploadIdentity2,
  getIdentity,
  onlineOCR,
  uploadIdCard,
  uploadFrontCard,
  uploadBackCard,
  updatedIdentity,
  updateSingelChannel,
  getTencentSDKSign,
};

export default BioApi;
